import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { I18nProvider } from '@ayeldo/frontend-core/i18n/I18nProvider';
import { createAyeldoTheme } from '@ayeldo/ui/theme/create-theme';

import { App } from './App';
import { initIdpI18n } from './i18n-setup';

initIdpI18n();

const IDP_THEME = createAyeldoTheme({
  appearance: 'light',
  primaryColor: '#12A594',
  grayTone: 'neutral',
  borderRadius: 12,
  fontFamily: "'Be Vietnam Pro', sans-serif",
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider theme={IDP_THEME}>
      <CssBaseline />
      <BrowserRouter>
        <I18nProvider>
          <App />
        </I18nProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>
);
